goog.provide("shadow.js.shim.module$src$svg$files_folders$image_stack_svg$default");
shadow.js.shim.module$src$svg$files_folders$image_stack_svg$default = shadow.js.shim.module$src$svg$files_folders$image_stack_svg.default;
